import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchLeadFormThunk } from 'shared/lib';
import { placeSchema } from 'entities/place';
import BaseError from '../../../utils/base-error';
import { PlacePageState } from './state';
import { PlacePageActions } from './actions';

const initialState: PlacePageState = {
    loaded: false,
    errors: [],
};

export const placePageSlice = createSlice({
    name: 'placePageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            PlacePageActions.getPlaceByUid.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        const { data } = response.data;

                        state.place = placeSchema.parse(data);
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
